module.exports = __webpack_public_path__ + "img/toctoc_2.a06d8703.jpg";